export const FETCH_COMMENT_REQUEST = "comment/FETCH_COMMENT_REQUEST";
export const FETCH_COMMENT_SUCCESS = "comment/FETCH_COMMENT_SUCCESS";
export const FETCH_COMMENT_FAILURE = "comment/FETCH_COMMENT_FAILURE";

export const UPDATE_COMMENT_REQUEST = "comment/UPDATE_COMMENT_REQUEST";
export const UPDATE_COMMENT_SUCCESS = "comment/UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAILURE = "comment/UPDATE_COMMENT_FAILURE";
